// SPDX-FileCopyrightText: Copyright 2025 Dash0 Inc.

import React from "react";

export function rewriteHeadingIds(
    node: React.ReactNode,
    parentId: string,
): React.ReactNode {
    return React.Children.map(node, (child) => {
        if (!React.isValidElement(child)) return child;

        const el = child as React.ReactElement<any>;

        const elementType = el.type;
        const isHeading =
            typeof elementType === "string" &&
            (elementType === "h1" || elementType === "h2");

        if (isHeading && typeof el.props.id === "string") {
            const newId = `${parentId.slice(0, -8)}-${el.props.id}`;
            return React.cloneElement(el, { id: newId });
        }

        if (el.props.children) {
            const newChildren = rewriteHeadingIds(el.props.children, parentId);
            return React.cloneElement(el, { children: newChildren });
        }

        return el;
    });
}